<template>
    <div class="empty-wrap" :style="border?'border: 1px solid #ddd;background:#fff':''">
        <div class="empty-inner">
            <div class="empty-icon">
                <Icon type="ios-alert-outline" size="32"/>
            </div>
            <div class="empty-txt">
                <p class="main-title">{{title}}</p>
                <p class="desc-txt" v-html="txt"></p>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props:{
            title:String,
            txt:String,
            border:Boolean
        },
        name: "empty_wrap"
    }
</script>

<style scoped lang="less">
    .empty-wrap {
        padding: 100px 0;
        box-sizing: border-box;
       .empty-inner {
            display: table;
            margin: 0 auto;
           .empty-icon {
               display: table-cell;
               padding-right: 20px;
               vertical-align: top;
           }
           .empty-txt {
               display: table-cell;
               padding-top: 3px;
               vertical-align: top;
               .main-title {
                   font-size: 18px;
                   line-height: 1.5;
               }
               .desc-txt {
                   font-size: 14px;
                   color: #888;
                   line-height: 1.5;
                   margin-top: 8px;
               }
               .desc-txt>a {
                   color: #00a4ff;
                   padding: 0 3px;
               }
           }
        }
    }
</style>